<template>
  <div class="trade-order-block">
    <div class="block-title">门店执行信息</div>
    <div class="block-title block-sub-title">{{ orderExecType }}</div>
    <div class="block-content" >
      <el-row class="content-row">
        <BaseCell :value="tradeApplyExecVO.brandName" label="主品牌" />
        <BaseCell :value="tradeApplyExecVO.subBrandName" label="子品牌" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="getImg(ispOrderData.pocCashierPhotoUri)" label="收银区/吧台照片" isImg />
        <BaseCell :value="getImg(ispOrderData.pocMenuPhotoUri)" label="酒水菜单页照片" isImg />
      </el-row>
      <el-row class="content-row">
        <el-col :span="3">户外区域/其他重点区域照片</el-col>
        <el-col :span="21"
          v-viewer="{movable: true}"
          class="info-img"
        >
          <div v-if="tradeApplyInfoVO.extraPhotoList && tradeApplyInfoVO.extraPhotoList.length">
            <div class="img-wrapper" v-for="img in tradeApplyInfoVO.extraPhotoList" :key="img.title">
              <img :src="getImg(img.imageUri)" />
            </div>
          </div>
          <div v-else>暂无</div>
        </el-col>
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="ispOrderData.drinkAreaName" label="有无户外就餐/饮酒区" />
        <BaseCell :value="ispOrderData.weekendFullSeatName" label="周末满座率" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="ispOrderData.dianpinScoreName" label="大众点评评分" />
        <BaseCell :value="ispOrderData.displayTimeName" label="陈列保留时间" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="ispOrderData.pocArea" label="店家面积" />
        <BaseCell :value="ispOrderData.pocStyleName" label="店家装修风格" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="customLocationNameListName" label="定制位置" />
        <BaseCell :value="ispOrderData.pocFormName" label="主要娱乐形式" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="ispOrderData.customLocationDesc" label="定制位置补充说明" />
        <BaseCell :value="tradeApplyExecVO.investAmount" label="预计投入金额" numberFormat valueUnit="元" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="tradeApplyBaseVO.keyContactPerson" label="联系人姓名" />
        <BaseCell :value="tradeApplyInfoVO.salesContactPerson" label="业务员姓名" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="tradeApplyBaseVO.keyContactPhone" label="联系人电话" />
        <BaseCell :value="tradeApplyInfoVO.salesContactPhone" label="业务员电话" />
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="tradeApplyInfoVO.applyDesc" label="提报说明" allCell />
      </el-row>
    </div>
  </div>
</template>

<script>
import BaseCell from '@/components/base-cell'
import { commonUtils } from '@/utils/common'
export default {
  name: 'order-exec-cooler',
  components: {
    BaseCell
  },
  props: {
    tradeApplyExecVO: {
      type: Object,
      default: () => {}
    },
    tradeApplyBaseVO: {
      type: Object,
      default: () => {}
    },
    tradeApplyInfoVO: {
      type: Object,
      default: () => {}
    },
    ispOrderData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {}
  },
  computed: {
    orderExecType () {
      if (this.tradeApplyExecVO?.execTypeSub) {
        const typeNameMap = {
          '301': 'ISP高端执行',
          '302': 'ISP形象店',
          '303': 'ISP物料定制'
        }
        return typeNameMap[this.tradeApplyExecVO?.execTypeSub]
      }
      return ''
    },

    customLocationNameListName () {
      if (this.ispOrderData?.customLocationNameList?.length) {
        return this.ispOrderData.customLocationNameList.join(',')
      }
      return ''
    }
  },
  created () {},
  methods: {
    getImg (uri) {
      if (!uri) return null
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
